import { render, staticRenderFns } from "./currencyPlan.vue?vue&type=template&id=131634e2"
import script from "./currencyPlan.vue?vue&type=script&lang=js"
export * from "./currencyPlan.vue?vue&type=script&lang=js"
import style0 from "./currencyPlan.vue?vue&type=style&index=0&id=131634e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports